import { getLandingExamples, getTemplates } from '../data/gameExamples';
import { getLandingTemplates } from '../services/templateService';

const staticFallbackGames = getLandingExamples().slice(0, 9);
const fallbackByGameType = new Map(staticFallbackGames.map((game) => [game.gameType, game]));
const staticPlayableTemplates = getTemplates();

export function normaliseLandingGame(template) {
  const fallback = fallbackByGameType.get(template.gameType) || {};

  return {
    id: template.id || template.campaignId || fallback.id,
    campaignId: template.campaignId || fallback.campaignId,
    name: template.name || fallback.name || template.gameType || 'Game template',
    gameType: template.gameType || fallback.gameType,
    gameTypeBadge: template.gameTypeBadge || template.gameType || fallback.gameTypeBadge,
    imageUrl: template.imageUrl || fallback.imageUrl,
    description: template.description || template.useCase || fallback.description,
    tag: template.tag || template.label || fallback.tag,
  };
}

export function getStaticLandingGames() {
  return staticFallbackGames.map(normaliseLandingGame).filter((game) => game.id && game.gameType);
}

export function getStaticLandingSampleGames() {
  return staticPlayableTemplates
    .map(normaliseLandingGame)
    .filter((game) => game.campaignId && game.gameType);
}

export async function loadLandingGames() {
  const templates = await getLandingTemplates();
  const games = templates
    .map(normaliseLandingGame)
    .filter((game) => game.id && game.gameType && game.imageUrl)
    .slice(0, 9);

  return games.length > 0 ? games : getStaticLandingGames();
}

export async function loadLandingSampleGames() {
  const templates = await getLandingTemplates();
  const games = templates
    .map(normaliseLandingGame)
    .filter((game) => game.campaignId && game.gameType)
    .slice(0, 9);

  return games.length > 0 ? games : getStaticLandingSampleGames();
}

export function pickRandomLandingGame(games) {
  const candidates = Array.isArray(games) && games.length > 0 ? games : getStaticLandingGames();
  return candidates[Math.floor(Math.random() * candidates.length)];
}
